module.exports = __webpack_public_path__ + "img/symbol_2.eaa02e6a.png";